import { ModalController } from '../modal-controller';

export class PayoutRequestsController extends ModalController {
  static targets = ["inputField", "payoutAmountField", "payoutAmountLabel"]

  openModal(event) {
    //
    this.payoutAmountLabelTarget.textContent = Number(this.inputFieldTarget.value).toLocaleString();
    this.payoutAmountFieldTarget.value = this.inputFieldTarget.value;
    //
    super.openModal(event);
  }
}